import { z } from 'zod';
// ---------------------------------------------------------------------------
// The three dedup/event ledgers migrated from the daemon (design §8, §12):
//   1. intraday alert dedup — one alert per (user, day, alert_key)
//   2. granola-processed dedup — which Granola meeting notes were ingested
//   3. rule-proposal log — proposed rules, logged/rendered, NEVER auto-applied
// ---------------------------------------------------------------------------
/** Intraday alert dedup ledger — suppresses re-alerting on the same item in a day. */
export const IntradayAlertLedgerSchema = z
    .object({
    ledger_id: z.string().min(1),
    day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/u),
    /** dedup key for the alert (e.g. item_id or a synthetic alert signature) */
    alert_key: z.string().min(1),
    item_id: z.string().nullable(),
    created_at: z.string(),
})
    .strict();
/** Granola-processed dedup — keyed by the Granola note id. */
export const GranolaProcessedSchema = z
    .object({
    granola_id: z.string().min(1),
    processed_at: z.string(),
})
    .strict();
export const RULE_PROPOSAL_STATUSES = ['proposed', 'accepted', 'rejected'];
/** Rule proposals the agent surfaces. Logged/rendered only — never auto-applied. */
export const RuleProposalSchema = z
    .object({
    proposal_id: z.string().min(1),
    proposal_md: z.string(),
    rationale_md: z.string().nullable(),
    status: z.enum(RULE_PROPOSAL_STATUSES),
    created_at: z.string(),
    decided_at: z.string().nullable(),
})
    .strict();
